import React, { useState, useEffect } from 'react';
import { Modal, Checkbox, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { CustomModalBody, CustomModalFooter, CustomModalHeader } from './style-component';
import CustomButton from '../custom-button/custom-button';
import brandData from "@/assets/brand.json"

const { Title } = Typography;

const EnterSiteWarning: React.FC = () => {

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [dontShowAgain, setDontShowAgain] = useState<boolean>(false);

  useEffect(() => {
    const hideModal = localStorage.getItem('hideEnterSiteWarning');
    if (hideModal === 'true') {
      setIsModalOpen(false);
    } else {
      setIsModalOpen(true);
    }
  }, []);

  const handleCheckboxChange = (e: CheckboxChangeEvent) => {
    setDontShowAgain(e.target.checked);
  };

  const handleClose = () => {
    if (dontShowAgain) {
      localStorage.setItem('hideEnterSiteWarning', 'true');
    }
    setIsModalOpen(false);
  };

  return (
    <Modal
      open={isModalOpen}
      title={
        <CustomModalHeader>
          <Title style={{ textAlign: "center" }} level={2}>Estás entrando a</Title>
          <div style={{ padding: "32px 0 32px 0" }}>
            <img src='/logo-light.svg' alt='app logo' style={{ marginLeft: "auto", width: "100%", maxHeight: "64px" }} />
          </div>
        </CustomModalHeader>
      }
      onCancel={() => setIsModalOpen(false)}
      closable={false}
      styles={{
        body: {
          padding: 0,
        },
        header: {
          padding: 0,
        },
        footer: {
          padding: 0,
        },
        content: {
          padding: 0,
          borderRadius: "32px",
          overflow: "hidden"
        }
      }}
      footer={[
        <CustomModalFooter key="footer">
          <Checkbox checked={dontShowAgain} onChange={handleCheckboxChange}>
            No mostrar de nuevo
          </Checkbox>
          <CustomButton data-testid="confirm-button" key="close" type='primary' onClick={handleClose}>
            Entendido
          </CustomButton>
        </CustomModalFooter>,
      ]}
    >
      <CustomModalBody>
        <p>
          Este es un espacio independiente de <b>{brandData.main.name}</b>, sin relación directa con la plataforma principal.
          <br />
          <br />
          ¡Aquí explorarás nuevas funciones y podrás ganar experiencias exclusivas!
        </p>
      </CustomModalBody>
    </Modal>
  );
};

export default EnterSiteWarning;